export const Social = {
  align: "enum(left,right,center)",
  "border-radius": "unit(px,%)",
  "container-background-color": "color",
  color: "color",
  "font-family": "string",
  "font-size": "unit(px)",
  "font-style": "string",
  "font-weight": "string",
  "icon-size": "unit(px,%)",
  "icon-height": "unit(px,%)",
  "icon-padding": "unit(px,%){1,4}",
  "inner-padding": "unit(px,%){1,4}",
  "line-height": "unit(px,%,)",
  mode: "enum(horizontal,vertical)",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-top": "unit(px,%)",
  padding: "unit(px,%){1,4}",
  "table-layout": "enum(auto,fixed)",
  "text-padding": "unit(px,%){1,4}",
  "text-decoration": "string",
  "vertical-align": "enum(top,bottom,middle)",
};
